import { useCallback } from 'react';
import { JWT_TOKEN } from './constants';
import toast from 'react-hot-toast';

export const useOnBuyClick = () => {
  return useCallback(async (priceId: string) => {
    try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/payments/create-checkout-session/${priceId}`,
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ priceId })
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to create checkout session");
    }

    const data = await response.json();

    // Redirect to Stripe checkout
    window.location.href = data.url;
  } catch (error) {
    toast.error('Failed to create checkout session');
  }
  }, []);
};

export const useOnGetBillingPortal = () => {
  return useCallback(async () => {
    try {
      const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/payments/create-billing-portal-url`,
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${localStorage.getItem(JWT_TOKEN)}`,
          "Content-Type": "application/json"
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to create checkout session");
    }

    const data = await response.json();

    // Redirect to Stripe checkout
    window.location.href = data.url;
    } catch (error) {
    }
  }, [])
}